<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-shtax-400 hover:text-shtax-600" :href="route('clients')">Klienci</inertia-link>
      <span class="text-shtax-400 font-medium">/</span>
      <inertia-link class="text-shtax-400 hover:text-shtax-600" :href="route('clients.show', client.id)">{{ client.firma ? client.firma.NAZWA_PELNA : client.nazwa_pelna }}</inertia-link>
      <span class="text-shtax-400 font-medium">/</span>
      Nowy kontakt/udziałowiec
    </h1>
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="store">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">

          <div class="bg-gray-100 -ml-3 -mt-3 mb-3 p-3 w-full flex flex-wrap">
            <multiselect-input v-model="form.udzialowiec" :error="form.errors.udzialowiec" class="lg:pr-3 pb-8 w-full lg:w-1/2" :options="client.firma.udzialowcy" track_by="id" opt_label="name" :multiple="false" :close_on_select="true" label="Udziałowiec [WAPRO]" :searchable="true" @input="onChange" :isDisabled="form.is_new_udzialowiec" />

            <shtax-checkbox class="lg:pl-3 pr-6 pb-6 pt-0 lg:pt-8 w-full lg:w-1/2" v-model:checked.sync="form.is_new_udzialowiec" :error="form.errors.is_new_udzialowiec" :checked="form.is_new_udzialowiec" label="Nowy udziałowiec" />

              <multiselect-input v-model="form.urzad" :error="form.errors.urzad" class="pb-8 w-full" :options="urzedy" track_by="id" opt_label="name" :multiple="false" :close_on_select="true" label="Urząd Skarbowy" :searchable="true" v-if="form.is_new_udzialowiec" />

              <span class="w-full pb-3" v-if="form.is_new_udzialowiec">Forma opodatkowania:</span>
              <shtax-checkbox v-if="form.is_new_udzialowiec" class="pr-6 pb-3 w-1/2" v-model:checked.sync="form.is_main" :error="form.errors.is_main" :checked="form.is_main" :disabled="form.is_ryczalt" label="Ogólny" />
              <shtax-checkbox v-if="form.is_new_udzialowiec" class="pl-3 pr-6 pb-3 w-1/2" v-model:checked.sync="form.is_ryczalt" :error="form.errors.is_ryczalt" :checked="form.is_ryczalt" :disabled="form.is_main" label="Ryczałt" />
              <shtax-checkbox v-if="form.is_new_udzialowiec" class="pr-6 w-1/2" v-model:checked.sync="form.is_liniowy" :error="form.errors.is_liniowy" :checked="form.is_liniowy" :disabled="!form.is_main" label="Liniowy" />
            
          </div>

          <text-input v-model="form.first_name" :error="form.errors.first_name" class="pr-6 pb-8 w-full lg:w-1/2" label="Imię" />
          <text-input v-model="form.last_name" :error="form.errors.last_name" class="pr-6 pb-8 w-full lg:w-1/2" label="Nazwisko" />
          <text-input v-model="form.phone" :error="form.errors.phone" class="pr-6 pb-8 w-full lg:w-1/2" label="Telefon" />
          <text-input v-model="form.email" :error="form.errors.email" class="pr-6 pb-8 w-full lg:w-1/2" label="Adres e-mail" />
          <text-input v-model="form.pesel" :error="form.errors.pesel" class="pr-6 pb-8 w-full lg:w-1/2" label="PESEL" />
          <text-input v-model="form.stanowisko" :error="form.errors.stanowisko" class="pr-6 pb-8 w-full lg:w-1/2" label="Stanowisko" />

          

          <shtax-checkbox class="pr-6 pb-8 w-1/2 lg:w-1/3" v-model:checked.sync="form.is_default" :error="form.errors.is_default" :checked="form.is_default" label="Domyślny" />
          <shtax-checkbox class="pr-6 pb-8 w-1/2 lg:w-1/3" v-model:checked.sync="form.is_ceo" :error="form.errors.is_ceo" :checked="form.is_ceo" label="Właściciel" />
          <shtax-checkbox class="pr-6 pb-8 w-1/2 lg:w-1/3" v-model:checked.sync="form.is_contract_representative" :error="form.errors.is_contract_representative" :checked="form.is_contract_representative" label="Reprezentant na umowie" />

          <shtax-text-area-input class="pr-6 pb-8 w-full" v-model="form.notice" :error="form.errors.notice" label="Uwagi"  />
        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
          <loading-button :loading="form.processing" class="btn-shtax" type="submit">Stwórz kontakt</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import ShtaxCheckbox from '@/ShtaxComponents/Checkbox'
import ShtaxTextAreaInput from '@/ShtaxComponents/TextAreaInput'
import MultiselectInput from '@/ShtaxComponents/MultiselectInput'

export default {
  metaInfo: { title: 'Nowy kontakt/udziałowiec' },
  components: {
    LoadingButton,
    TextInput,
    ShtaxCheckbox,
    ShtaxTextAreaInput,
    MultiselectInput
  },
  layout: Layout,
  props: {
    client: Object,
    urzedy: Array
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        first_name: null,
        last_name: null,
        email: null,
        phone: null,
        pesel: null,
        is_default: this.client.contacts.length == 0 ? true : false,
        is_ceo: false,
        notice: null,
        udzialowiec: null,
        is_new_udzialowiec: true,
        is_main: false,
        is_ryczalt: false,
        is_liniowy: false,
        urzad: this.client.urzad,
        stanowisko: null,
        is_contract_representative: false
      }),
    }
  },
  methods: {
    store() {
      this.form.post(this.route('contacts.store', this.client.id))
    },

    onChange(val) {
      this.form.first_name = val.imie
      this.form.last_name = val.nazwisko
      this.form.pesel = val.pesel
    }
  }
}
</script>
